<template>
  <v-container grid-list-md>
    <v-layout wrap>
      <v-flex xs12 sm12 md12>
        <v-toolbar>
          <v-toolbar-title>
            [日期]: {{edItem.pn_d}},
            [客户]: {{edItem.customer_title}}<br>
            [产品]: {{edItem.formula_code}} - {{edItem.formula_name}},
            [釜数]: {{edItem.pn_num}},
            [批次号]: {{edItem.batch_no}}
        </v-toolbar-title>
            <v-spacer></v-spacer>
            <v-btn small color="info" @click="addMix"><v-icon>playlist_add</v-icon>添加混料</v-btn>
            <v-dialog v-model="dlgMix" max-width="600px">
              <v-card>
                <v-card-title>
                  <span class="headline">添加混料</span>
                </v-card-title>
                <v-card-text>
                  <v-container>
                    <v-row>
                      <v-col cols="2" class="fld">
                        <span class="flds">序号</span>
                      </v-col>
                      <v-col cols="10">
                        <v-text-field v-model="edMi.pots" dense solo label="序号(all,every,1,2...)"></v-text-field>
                      </v-col>
                    </v-row>
                    <v-row>
                      <v-col cols="2" class="fld">
                        <span class="flds">混料名称</span>
                      </v-col>
                      <v-col cols="10">
                        <v-combobox
                          :items="nameitems"
                          v-model="edMi.name"
                          label="混料名称"
                          dense solo
                        ></v-combobox>
                      </v-col>
                    </v-row>
                    <v-row>
                      <v-col cols="2" class="fld">
                        <span class="flds">重量(kg)</span>
                      </v-col>
                      <v-col cols="10">
                        <v-text-field v-model="edMi.weight" dense solo label="重量(kg)"></v-text-field>
                      </v-col>
                    </v-row>
                  </v-container>
                </v-card-text>
                <v-card-actions>
                  <v-spacer></v-spacer>
                  <v-btn color="primary" text small @click="cancelMi">取消</v-btn>
                  <v-btn color="primary" small @click="saveMi">确定</v-btn>
                </v-card-actions>
              </v-card>
            </v-dialog>
            <v-btn small icon color="success" @click="addPot"><v-icon>add</v-icon></v-btn>
        </v-toolbar>
        <div>
        </div>
        <v-container style="min-height: 300px;" class="scroll-y">
        <v-data-table
          :headers="headers"
          :items="items"
          hide-default-footer
          disable-pagination
          class="elevation-2"
        >
          <template v-slot:item.kind="props">
            <v-edit-dialog
              :return-value.sync="props.item.kind"
              large
              cancel-text="取消"
              save-text="确定"
              @save="save('kind', props.item.pot_no)"
            >
              {{props.item.kind}}
              <template v-slot:input>
                <div slot="input" close="mt-3 title">类别</div>
                <v-combobox
                  :items="kinditems"
                  class="mx-3"
                  dense solo
                  label="类别"
                  v-model="props.item.kind"
                ></v-combobox>
                <v-checkbox v-model="aAll" label="应用所有"></v-checkbox>
              </template>
            </v-edit-dialog>
          </template>
          <template v-slot:item.pd_weight="props">
            <v-edit-dialog
              :return-value.sync="props.item.pd_weight"
              large
              cancel-text="取消"
              save-text="确定"
              @save="save('pd_weight', props.item.pot_no)"
            >
            {{ props.item.pd_weight }}
            <template v-slot:input>
              <div slot="input" close="mt-3 title">实际重量</div>
                <v-text-field
                  v-model="props.item.pd_weight"
                  label="实际重量"
                  single-line
                  dense solo
                  autofocus
                >
                </v-text-field>
                <v-checkbox v-model="aAll" label="应用所有"></v-checkbox>
              </template>
            </v-edit-dialog>
          </template>
          <template v-slot:item.mixs="props">
            <v-chip
              v-for="(mi,index) in props.item.mixs"
              :key="index"
              @click:close="rmMix(props.item.pot_no, mi.name)"
              close
              small
              color="green"
              outlined
            >{{mi.name}}({{mi.weight}}kg)
            </v-chip>
          </template>
          <template v-slot:item.pkg_num="props">
            <v-edit-dialog
              :return-value.sync="props.item.pkg_num"
              large
              cancel-text="取消"
              save-text="确定"
              @save="save('pkg_num', props.item.pot_no)"
            >
            {{ props.item.pkg_num }}
            <template v-slot:input>
            <div class="mt-3 title">打包数</div>
              <v-text-field
                v-model="props.item.pkg_num"
                label="打包数"
                single-line
                dense solo
                autofocus
              >
              </v-text-field>
              <v-checkbox v-model="aAll" label="应用所有"></v-checkbox>
            </template>
            </v-edit-dialog>
          </template>
          <template v-slot:item.temp="props">
            <v-edit-dialog
              :return-value.sync="props.item.temp"
              large
              cancel-text="取消"
              save-text="确定"
              @save="save('temp', props.item.pot_no)"
            >
            {{ props.item.temp }}
            <template v-slot:input>
            <div slot="input" close="mt-3 title">料温</div>
              <v-text-field
                v-model="props.item.temp"
                label="料温"
                single-line
                dense solo
                autofocus
              >
              </v-text-field>
              <v-checkbox v-model="aAll" label="应用所有"></v-checkbox>
            </template>
            </v-edit-dialog>
          </template>
          <template v-slot:item.dev_no="props">
            <v-edit-dialog
              :return-value.sync="props.item.dev_no"
              large
              cancel-text="取消"
              save-text="确定"
              @save="save('dev_no', props.item.pot_no)"
            >
            {{ props.item.dev_no }}
            <template v-slot:input>
            <div slot="input" close="mt-3 title">设备号</div>
              <v-text-field
                v-model="props.item.dev_no"
                label="设备号"
                single-line
                dense solo
                autofocus
              >
              </v-text-field>
              <v-checkbox v-model="aAll" label="应用所有"></v-checkbox>
            </template>
            </v-edit-dialog>
          </template>
          <template v-slot:item.cage_no="props">
            <v-edit-dialog
              :return-value.sync="props.item.cage_no"
              large
              cancel-text="取消"
              save-text="确定"
              @save="save('cage_no', props.item.pot_no)"
            >
            {{ props.item.cage_no }}
            <template v-slot:input>
            <div slot="input" close="mt-3 title">仓储笼号</div>
              <v-text-field
                :readonly="props.item.cage_st > 0"
                v-model="props.item.cage_no"
                label="仓储笼号"
                single-line
                dense solo
                autofocus
              >
              </v-text-field>
              <v-checkbox v-model="aAll" label="应用所有"></v-checkbox>
            </template>
            </v-edit-dialog>
          </template>
          <template v-slot:item.act="{item}">
            <v-icon v-show="item.can_rm" @click="rmPot(item.pot_no)" color="error">delete</v-icon>
          </template>
        </v-data-table>
        </v-container>
      </v-flex>
      <v-flex xs6 sm4 md2>
        <v-text-field v-model="edItem.pd_weight" label="实际生产重量(kg)"></v-text-field>
      </v-flex>
      <v-flex xs6 sm4 md2>
        <v-text-field v-model="edItem.pd_weight_0" readonly label="理论生产重量(kg)"></v-text-field>
      </v-flex>
      <v-flex xs6 sm4 md2>
        <v-text-field v-model="edItem.pd_weight_mix" readonly label="混料重量(kg)"></v-text-field>
      </v-flex>
      <v-flex xs6 sm4 md2>
        <v-text-field v-model="edItem.pkg_num" label="打包/箱数"></v-text-field>
      </v-flex>
      <v-flex xs12 sm12 md12>
        <v-text-field v-model="edItem.note" label="备注"></v-text-field>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<style>

</style>

<script>
import { getProducePotList, getPotKindList, setProduce, getProduceMixNameList } from '@/api/produce'
import { getFormula } from '@/api/formula'
import { splitStr } from '@/libs/tools'
import { MsgError } from '@/libs/util';

export default {
  name: 'ProduceA',
  data () {
    return {
      customer_title: '',
      product_name: '',
      kinditems: [],
      aAll: false,
      edItem: {
        id: 0,
        kind: '',
        customer_title: '',
        formula_name: '',
        pd_weight: 0,
        pd_weight_0: 0,
        pd_weight_mix: 0,
        pkg_num: 0,
        pkg_unit: '',
        note: ''
      },
      edMi: {
        pots: '',
        name: '',
        weight: 0
      },
      dlgMix: false,
      nameitems: [],
      items: [],
      headers: [
        { text: '类别', value: 'kind', sortable: false },
        { text: '序号', value: 'idx', sortable: false },
        { text: '釜号', value: 'pot_no', sortable: false },
        { text: '实际重量', value: 'pd_weight', sortable: false },
        { text: '混料', value: 'mixs', sortable: false },
        { text: '打包数', value: 'pkg_num', sortable: false },
        { text: '料温', value: 'temp', sortable: false },
        { text: '设备号', value: 'dev_no', sortable: false },
        { text: '仓储笼号', value: 'cage_no', sortable: false },
        { text: '操作', value: 'act', sortable: false }
      ],
      formula: null
    }
  },
  methods: {
    rmMix (potno, name) {
      for (var i = 0; i < this.items.length; ++i) {
        if (this.items[i].pot_no === potno) {
          var mm = this.items[i].mixs
          if (mm !== undefined) {
            for (var j = 0; j < mm.length; ++j) {
              if (mm[j].name === name) {
                mm.splice(j, 1)
                this.dlgMix = true
                this.dlgMix = false
                this.updateMixWeight(this.items[i])
                this.updateWeight(true)
                return
              }
            }
          }
        }
      }
    },
    addMix () {
      this.loadNameList()
      this.dlgMix = true
    },
    cancelMi () {
      this.dlgMix = false
    },
    saveMi () {
      var lst = []
      var i
      if (this.edMi.pots === 'all' || this.edMi.pots === 'every') {
        for (i = 0; i < this.items.length; ++i) {
          lst.push(this.items[i]['idx'])
        }
      } else {
        var ss = splitStr(this.edMi.pots)
        for (var ii in ss) {
          var s = ss[ii]
          var p = s.indexOf('-')
          if (p > 0) {
            var s1 = s.substr(0, p).trim()
            var s2 = s.substr(p + 1).trim()
            for (var j = parseInt(s1); j <= parseInt(s2); ++j) {
              lst.push(j)
            }
          } else {
            lst.push(parseInt(s))
          }
        }
      }
      if (lst.length === 0) {
        MsgError('序号设置不对')
      }
      if (this.edMi.name === undefined || this.edMi.name === '') {
        MsgError('混料名称不对')
        return
      }
      var weight = parseFloat(this.edMi.weight)
      if (weight <= 0) {
        MsgError('混料重量不对')
        return
      }
      for (var k in lst) {
        var pn = lst[k]
        for (i = 0; i < this.items.length; ++i) {
          var e = this.items[i]
          if (e['idx'] === pn) {
            this.addMixItem(e, this.edMi.name, weight)
            this.updateMixWeight(e)
            break
          }
        }
      }
      this.edMi.pots = ''
      this.edMi.name = ''
      this.edMi.weight = 0
      this.updateWeight(true)
      this.dlgMix = false
    },
    updateMixWeight (it) {
      var w = 0
      it.mixs.forEach(e => {
        w += e.weight
      })
      it.pd_weight = this.formula.weight + w
    },
    addMixItem (it, name, weight) {
      if (it['mixs'] === undefined) {
        it['mixs'] = []
      }
      var fd = false
      it['mixs'].some(e => {
        if (e['name'] === name) {
          e['weight'] += weight
          fd = true
          return true
        }
        return false
      })
      if (!fd) {
        var o = {}
        o['name'] = name
        o['weight'] = weight
        it['mixs'].push(o)
      }
    },
    rmPot (potNo) {
      for (var i = 0; i < this.items.length; ++i) {
        if (this.items[i].pot_no === potNo) {
          this.items.splice(i, 1)
          return
        }
      }
    },
    addPot () {
      var oo = null
      if (this.items.length > 0) {
        oo = this.items[this.items.length - 1]
      }
      var ii = Object()
      ii['idx'] = this.items.length + 1
      ii['pot_no'] = this.edItem.fm_no + this.items.length;
      ii['kind'] = oo === null ? '量产' : oo.kind
      ii['pkg_num'] = oo === null ? 1 : oo.pkg_num
      ii['temp'] = oo === null ? 0 : oo.temp
      ii['dev_no'] = oo === null ? '' : oo.dev_no
      ii['cage_no'] = oo === null ? '0' : oo.cage_no
      ii['pd_weight'] = oo === null ? this.formula.weight : oo.pd_weight
      ii['mixs'] = []
      ii['pkg_unit'] = oo === null ? this.formula.pkg : oo.pkg_unit
      ii['can_rm'] = true
      this.items.push(ii)
      this.updateWeight(true)
      this.updatePkgNum()
    },
    save (fd, potNo) {
      var v = ''
      var i
      if (this.aAll) {
        for (i = 0; i < this.items.length; ++i) {
          if (this.items[i].pot_no === potNo) {
            v = this.items[i][fd]
            break
          }
        }
        for (i = 0; i < this.items.length; ++i) {
          this.items[i][fd] = v
        }
        this.aAll = false
      }
      if (fd === 'pd_weight') {
        this.updateWeight(true)
      } else if (fd === 'pkg_num') {
        this.updatePkgNum()
      }
    },
    updateWeight (incw) {
      var tot = 0
      var mix = 0
      var fw = 0
      for (var i = 0; i < this.items.length; ++i) {
        tot += parseFloat(this.items[i]['pd_weight'])
        fw += this.formula.weight
        for (var j = 0; j < this.items[i].mixs.length; ++j) {
          mix += this.items[i].mixs[j].weight
        }
      }
      if (incw || parseFloat(this.edItem.pd_weight) <= 0.000001) {
        this.edItem.pd_weight = tot.toFixed(2)
      }
      this.edItem.pd_weight_mix = mix.toFixed(2)
      this.edItem.pd_weight_0 = fw.toFixed(2)
    },
    updatePkgNum () {
      var tot = 0
      for (var i = 0; i < this.items.length; ++i) {
        tot += parseInt(this.items[i]['pkg_num'])
      }
      this.edItem.pkg_num = tot
    },
    setData (it) {
      this.edItem = Object.assign({}, it)
      this.loadFormula()
      this.loadItems(it.id)
    },
    initItems () {
      this.items = []
      for (var i = 0; i < this.edItem.pn_num; ++i) {
        var ii = Object()
        ii['idx'] = i + 1
        ii['pot_no'] = this.edItem.fm_no + i;
        ii['kind'] = '量产'
        ii['pd_weight'] = this.formula.weight
        ii['mixs'] = []
        ii['pkg_num'] = 1
        ii['pkg_unit'] = this.formula.pkg
        ii['temp'] = 0
        ii['dev_no'] = ''
        ii['cage_no'] = 0
        ii['can_rm'] = false
        this.items.push(ii)
      }
      this.updateWeight()
      this.updatePkgNum()
    },
    loadItems (pdId) {
      getProducePotList(pdId).then(res => {
        this.items = res.data
        if (this.items.length === 0) {
          this.initItems()
        }
        this.updateWeight(false)
      })
    },
    loadKindList () {
      getPotKindList().then(res => {
        this.kinditems = res.data
      })
    },
    loadNameList () {
      getProduceMixNameList().then(res => {
        this.nameitems = res.data
      })
    },
    loadFormula () {
      getFormula(this.edItem.f_id).then(res => {
        this.formula = res.data
      })
    },
    submit () {
      let t = this
      return new Promise(function (resolve, reject) {
        setProduce(t.edItem.id, t.edItem.kind, t.edItem.pd_weight,
          t.edItem.pkg_num, t.edItem.pkg_unit, t.edItem.note, t.items).then(res => {
          resolve(res)
        }).catch(err => {
          reject(err)
        })
      })
    }
  },
  mounted () {
    this.loadKindList()
  }
}
</script>
